import { useState } from "react";
import { Link } from "react-router-dom";
import navbarData from "src/data/navbar-data.json";

function NavbarMenu({ onClick, menu_id, isMobile = false }) {
    // State to toggle the dropdown in mobile view
    const [isOpen, setIsOpen] = useState(false);
    
    const data = navbarData.filter(x => x.id === menu_id)[0];

    // Safety check just in case the data isn't found
    if (!data) return null;

    // --- MOBILE SIDEBAR LAYOUT ---
    if (isMobile) {
        return (
            <li className="flex flex-col w-full cursor-pointer">
                <div 
                    onClick={() => setIsOpen(!isOpen)} 
                    className="flex justify-between items-center py-[12px] px-[8px] text-lightBlack hover:text-black duration-100 font-medium"
                >
                    <span>{data.label}</span>
                    {/* Tiny arrow that rotates when open */}
                    <svg 
                        className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`} 
                        fill="none" stroke="currentColor" viewBox="0 0 24 24"
                    >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </div>
                
                {/* Expandable Mobile List */}
                <ul className={`
                    flex flex-col pl-[16px] overflow-hidden transition-all duration-300 ease-in-out
                    ${isOpen ? "max-h-[500px] opacity-100 mt-2" : "max-h-0 opacity-0"}
                `}>
                    {data.menu.map((x, index) => (
                        <li key={index} onClick={onClick} className="w-full">
                            <Link 
                                className="block hover:text-black hover:bg-darkenWhite w-full py-[10px] px-[12px] rounded-[8px] text-grey duration-300" 
                                to={x.url}
                            >
                                {x.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </li>
        );
    }

    // --- DESKTOP NAVBAR LAYOUT (Your original code) ---
    return (
        <li className="relative group">
            <Link className="px-[8px] text-lightBlack group-hover:text-black duration-100 cursor-pointer">
                {data.label}
            </Link>
            <ul className={`
                w-72 ${data.isRight ? "right-0" : "left-0"}
                group-hover:visible group-hover:opacity-100 group-hover:translate-y-0
                absolute text-lightBlack invisible text-left list-none px-[4px] py-[8px] bg-white border-[1px] 
                duration-200 transition-all ease-in-out z-50 -translate-y-1 opacity-0 rounded-[12px]
            `}>
                {data.menu.map((x, index) => (
                    // Added key prop to prevent React warnings
                    <li key={index} onClick={onClick} className="w-full">
                        <Link className="flex hover:text-black hover:bg-darkenWhite w-full py-[8px] px-[4px] rounded-[8px] duration-500" to={x.url}>
                            {x.label}
                        </Link>
                    </li>
                ))}
            </ul>
        </li>
    );
}

export default NavbarMenu;